export default "__VITE_ASSET__DzGe0SRe__"